// SPDX-License-Identifier: AGPL-3.0-or-later

import type {TableGameRankedKind} from '@fluxer/constants/src/TableGameConstants';
import type {TableGameRatingSummary} from '@fluxer/schema/src/domains/table_game/TableGameLeaderboardSchemas';
import {makeAutoObservable, observableRef} from 'mobx';

// My rating in one game before a ranked table started, and after the server recorded it. One table at a time.
export interface RankedResult {
	readonly tableKey: string;
	readonly game: TableGameRankedKind;
	readonly before: TableGameRatingSummary | null;
	readonly after: TableGameRatingSummary | null;
}

class TableGameRankedResult {
	result: RankedResult | null = null;

	constructor() {
		makeAutoObservable(this, {result: observableRef}, {autoBind: true});
	}

	setBaseline(tableKey: string, game: TableGameRankedKind, before: TableGameRatingSummary | null): void {
		this.result = {tableKey, game, before, after: null};
	}

	setAfter(tableKey: string, after: TableGameRatingSummary): void {
		if (this.result?.tableKey === tableKey) this.result = {...this.result, after};
	}

	clear(): void {
		this.result = null;
	}
}

export default new TableGameRankedResult();
